import { Component, HostListener, OnInit } from '@angular/core';
import { QuizService } from '../shared-service/services/quiz.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from '../app.config';
import { MetaService } from '../shared-service/services/meta-service.service';
import { PlatformLocation } from '@angular/common';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { fromEvent, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-daily-dose',
  templateUrl: './daily-dose.component.html',
  styleUrls: ['./daily-dose.component.css']
})
export class DailyDoseComponent implements OnInit {


  userData: any;

  showTopMenuBar = '';
  domain = '';
  titleName = '';
  imgWidth = '';
  imgHeight = '';
  extraMenuItems = '';
  socialLogin = '';
  isJeeWebsite = 1;
  isGovtWebsite = 1;
  logo = '';
  logo1 = '';

  activeFeatures=0;
  
featuresList = [ {
  index: 1,
  title: 'Free Users can only download ',
  description: "Current Affairs & Important News Analysis",
  url: 'assets/images/feature-2.jpg'
},
{
  index: 2,
  title: 'Please subscribe',
  description: "To Download all 8 PDF's daily",
  url: 'assets/images/feature-2.jpg',
  isSubscribeBtn: true
},
{
  index: 3,
  title: 'Already subscribed',
  description: 'Please click on login button',
  url: 'assets/images/feature-2.jpg',
  isLoginBtn: true
},
];

selectedHowItWorksSrc = '/assets/images/s-1.svg'

  private unsubscriber: Subject<void> = new Subject<void>();

  datetimevalue = '';
  pdfId = '';
  hrankerurl = '';
  baseurl='';
  mainbaseurl='';

  dailyDoseUsername = '';
  dailyDosePassword = '';
  baseHrankerurl='';

  constructor(
    private quizService: QuizService,
    private router: Router,
    private config: AppConfig,
    private metaServiceCustom: MetaService,
    private route: ActivatedRoute,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,

  ) {
    this.showTopMenuBar = this.config.getConfig('SHOW_TOP_MENU_BAR_AFTER_LOGIN');
    this.logo = this.config.getConfig('LOGO');
    this.logo1 = this.config.getConfig('LOGO1');
    this.domain = this.config.getConfig('DOMAIN');
    this.baseurl = this.config.getConfig('BASEURL');
    this.titleName = this.config.getConfig('TITLE');
    this.imgWidth = this.config.getConfig('LOGO_WIDTH');
    this.imgHeight = this.config.getConfig('LOGO_HEIGHT');
    this.mainbaseurl = this.config.getConfig('MAIN_BASE_URL');

    this.dailyDoseUsername = this.config.getConfig('DAILYDOSE_USERNAME');
    this.dailyDosePassword = this.config.getConfig('DAILYDOSE_PASSWORD');

    this.baseHrankerurl = 'https://hranker.com/daily-dose-login/' + this.dailyDoseUsername +'/' + this.dailyDosePassword;

  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: Event): void {
    debugger;
    // event.preventDefault();
    // console.log("BACK PRESSED");
    // this.location.forward();
    // this.stepper.previous();
  }

  ngOnInit() {
    history.pushState(null, '');
    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });
    this.quizService.clearTestCacheData();
    if (this.route.snapshot.paramMap.get('datetime-value')) {
      this.datetimevalue = this.route.snapshot.paramMap.get('datetime-value');
      this.pdfId = this.route.snapshot.paramMap.get('pdf-id');
      this.hrankerurl = 'https://hranker.com/daily-dose-login/' + this.dailyDoseUsername +'/' + this.dailyDosePassword +'/'+ this.datetimevalue + '/' + this.pdfId;
    }
  }

  logout() {
    // localStorage.removeItem('ds');
    // this.router.navigateByUrl('/');
    this.pdfId = '';
    window.location.href = this.mainbaseurl;
  }

  gotoplan() {
    // localStorage.removeItem('ds');
    window.location.href = this.mainbaseurl + '/study-plan'
  }

  gotoLogin() {
    // localStorage.removeItem('ds');
    window.location.href = '/';
  }

  setActiveFeatures(event) {
    this.activeFeatures = event;
    
  }

}
